/**
 * Simplify Monarch's auto-request format by returning rules
 * in a single group instead of separate rule sets.
 */
export function formatMonarchEvaluations(monarchResult) {
    if (!monarchResult) {
        return null;
    }
    const ruleSets = [];
    for (const [ruleSetName, ruleSet] of Object.entries(monarchResult)) {
        // NOTE: Exclude reserved "_Monarch" key, which is only used for debug responses.
        if (ruleSetName !== '_Monarch') {
            ruleSets.push(ruleSet);
        }
    }
    const rules = {};
    for (const ruleSet of ruleSets) {
        for (const [ruleId, ruleReturn] of Object.entries(ruleSet)) {
            rules[ruleId] = ruleReturn;
        }
    }
    return rules;
}
